(() => {
  'use strict';
  function enhance(modal) {
    if (modal.dataset.tksGalleryReady) return;
    const content = modal.querySelector('.product-media-modal-content');
    const dialog = modal.querySelector('.product-media-modal-dialog');
    if (!content || !dialog) return;
    const media = [...content.children].filter(el => el.hasAttribute('data-media-id'));
    if (!media.length) return;
    modal.dataset.tksGalleryReady = 'true';
    modal.classList.add('tks-lightbox');
    // Product title from the current product panel, not generic gallery wording.
    const productName = document.querySelector('.product-info-heading')?.textContent?.trim()
      || document.querySelector('h1')?.textContent?.trim() || 'Product images';
    const header = document.createElement('div');
    header.className = 'tks-lb-header';
    const title = document.createElement('span');
    title.className = 'tks-lb-product-title';
    title.textContent = productName;
    header.appendChild(title);
    dialog.prepend(header);
    const stage = document.createElement('div');
    stage.className = 'tks-lb-stage';
    content.parentNode.insertBefore(stage, content);
    stage.appendChild(content);
    // Tokyo closes media modals on any bubbled mouse pointerup. Keep navigation inside the modal.
    dialog.addEventListener('pointerup', event => event.stopPropagation());
    const side = document.createElement('aside');
    side.className = 'tks-lb-side';
    side.innerHTML = '<div class="tks-lb-thumbs" role="group" aria-label="Choose product image"></div><div class="tks-lb-footer"><span class="tks-lb-count" aria-live="polite"></span><div class="tks-lb-tools"><button type="button" data-tks-action="out" aria-label="Zoom out">−</button><button type="button" data-tks-action="in" aria-label="Zoom in">+</button><button type="button" data-tks-action="reset" aria-label="Reset zoom">Reset</button></div></div>';
    stage.parentNode.appendChild(side);
    const thumbs = side.querySelector('.tks-lb-thumbs');
    const controls = document.createElement('div');
    controls.className = 'tks-lb-arrows';
    controls.innerHTML = '<button type="button" data-tks-action="prev" aria-label="Previous image"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg></button><button type="button" data-tks-action="next" aria-label="Next image"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg></button>';
    stage.appendChild(controls);
    const buttons = media.map((el, i) => {
      const thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'tks-lb-thumb';
      thumb.setAttribute('aria-label', 'View media ' + (i + 1));
      const img = el.tagName === 'IMG' ? el : el.querySelector('img');
      if (img) {
        const picture = img.cloneNode(false);
        picture.removeAttribute('srcset');
        picture.removeAttribute('sizes');
        picture.removeAttribute('width');
        picture.removeAttribute('height');
        picture.loading = 'lazy';
        picture.alt = '';
        thumb.appendChild(picture);
      } else {
        thumb.textContent = 'Media ' + (i + 1);
      }
      thumb.addEventListener('click', () => select(i));
      thumbs.appendChild(thumb);
      return thumb;
    });
    let active = 0, zoom = 1, startX = null;
    let panX = 0, panY = 0, drag = null;
    const activeImage = () => media[active]?.tagName === 'IMG' ? media[active] : null;
    const applyView = () => {
      const img = activeImage();
      if (!img) return;
      // Bound the grab movement so the picture cannot be dragged entirely out of view.
      const viewport = content.getBoundingClientRect();
      const limitX = zoom === 1 ? Math.min(64, viewport.width * .09) : Math.max(0, (zoom - 1) * viewport.width / 2);
      const limitY = zoom === 1 ? Math.min(64, viewport.height * .09) : Math.max(0, (zoom - 1) * viewport.height / 2);
      panX = Math.min(limitX, Math.max(-limitX, panX));
      panY = Math.min(limitY, Math.max(-limitY, panY));
      img.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + zoom + ')';
      content.classList.toggle('tks-lb-can-grab', !!activeImage());
    };
    const reset = () => {
      zoom = 1;
      panX = 0;
      panY = 0;
      drag = null;
      content.classList.remove('tks-lb-can-grab', 'tks-lb-grabbing');
      media.forEach(el => { if (el.tagName === 'IMG') el.style.transform = ''; });
    };
    function select(index) {
      active = (index + media.length) % media.length;
      reset();
      media.forEach((el, i) => {
        const selected = i === active;
        el.classList.toggle('is-active', selected);
        el.setAttribute('aria-hidden', selected ? 'false' : 'true');
        buttons[i].classList.toggle('is-active', selected);
        buttons[i].setAttribute('aria-pressed', String(selected));
        if (!selected) el.querySelectorAll('video').forEach(v => v.pause());
      });
      side.querySelector('.tks-lb-count').textContent = (active + 1) + ' / ' + media.length;
      buttons[active].scrollIntoView({block:'nearest', inline:'nearest'});
      const el = media[active];
      content.classList.toggle('tks-lb-can-grab', !!activeImage());
      if (el.tagName === 'DEFERRED-MEDIA' && typeof el.loadContent === 'function') el.loadContent(false);
    }
    const act = action => {
      if (action === 'prev') select(active - 1);
      if (action === 'next') select(active + 1);
      if (action === 'reset') reset();
      if (action === 'in' || action === 'out') {
        if (media[active].tagName !== 'IMG') return;
        zoom = Math.min(3, Math.max(1, zoom + (action === 'in' ? .5 : -.5)));
        if (zoom === 1) { panX = 0; panY = 0; }
        applyView();
      }
    };
    modal.querySelectorAll('[data-tks-action]').forEach(b => b.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      act(b.dataset.tksAction);
    }));
    modal.addEventListener('keydown', e => {
      if (!modal.hasAttribute('open')) return;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        act(e.key === 'ArrowLeft' ? 'prev' : 'next');
      }
    });
    // Mouse/touch pointer capture for click-and-drag panning while zoomed.
    content.addEventListener('pointerdown', e => {
      if (!activeImage() || (e.pointerType === 'mouse' && e.button !== 0) || (zoom === 1 && e.pointerType !== 'mouse')) return;
      e.preventDefault();
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, baseX: panX, baseY: panY };
      content.classList.add('tks-lb-grabbing');
      content.setPointerCapture(e.pointerId);
    });
    content.addEventListener('pointermove', e => {
      if (!drag || e.pointerId !== drag.id) return;
      e.preventDefault();
      panX = drag.baseX + e.clientX - drag.x;
      panY = drag.baseY + e.clientY - drag.y;
      applyView();
    });
    const releaseDrag = e => {
      if (!drag || e.pointerId !== drag.id) return;
      drag = null;
      content.classList.remove('tks-lb-grabbing');
      if (content.hasPointerCapture(e.pointerId)) content.releasePointerCapture(e.pointerId);
    };
    content.addEventListener('pointerup', releaseDrag);
    content.addEventListener('pointercancel', releaseDrag);
    content.addEventListener('lostpointercapture', () => {
      drag = null;
      content.classList.remove('tks-lb-grabbing');
    });
    stage.addEventListener('touchstart', e => {
      if (e.touches.length === 1) startX = e.touches[0].clientX;
    }, {passive:true});
    stage.addEventListener('touchend', e => {
      if (startX === null || !e.changedTouches.length) return;
      const delta = e.changedTouches[0].clientX - startX;
      if (Math.abs(delta) > 55 && zoom === 1) act(delta < 0 ? 'next' : 'prev');
      startX = null;
    }, {passive:true});
    const observer = new MutationObserver(() => {
      if (modal.hasAttribute('open')) {
        const current = media.findIndex(el => el.classList.contains('is-active'));
        select(current >= 0 ? current : active);
      } else reset();
    });
    observer.observe(modal, {attributes:true, attributeFilter:['open']});
    select(media.findIndex(el => el.classList.contains('is-active')) >= 0 ? media.findIndex(el => el.classList.contains('is-active')) : 0);
  }
  const init = () => document.querySelectorAll('product-modal.product-media-modal').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();